import Component from './component';

Component.defaultProps = {
    children: null,
    sliderProps: {},
    customClass: '',
};

export default Component;
